import Repository from './Repository'

export default {
  get(payload) {
    return Repository.get('/coupons', payload)
  },
  post(payload) {
    return Repository.post('/coupons', payload)
  },
  detail(id) {
    return Repository.get('/coupons/' + id)
  },
  put(payload) {
    return Repository.put('/coupons/' + payload.id, payload)
  },
  delete(id) {
    return Repository.delete('/coupons/' + id)
  }
}

